module.exports = __webpack_public_path__ + "img/mie-ayam-bakso.f8415710.jpg";